import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useViewMode } from '@/context/view-mode.context';
import { isGentlyAIUser } from '@/utils/user';
import { useContext } from 'react';
import { AuthContext } from '@/context/auth.context';
import { T, useGT } from 'gt-react';

export function ViewModeToggle() {
  const gt = useGT();
  const { currentUser } = useContext(AuthContext);
  const { viewMode, toggleViewMode } = useViewMode();

  // Only show toggle for actual admins
  if (!isGentlyAIUser(currentUser)) {
    return null;
  }

  const isAdminView = viewMode === 'admin';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleViewMode}
            className="h-8 w-8"
            aria-label={
              isAdminView
                ? gt('Switch to end-user view', {
                    context: 'accessibility label for view mode toggle',
                  })
                : gt('Switch to admin view', {
                    context: 'accessibility label for view mode toggle',
                  })
            }
          >
            {isAdminView ? (
              <EyeIcon className="h-4 w-4" />
            ) : (
              <EyeSlashIcon className="h-4 w-4" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>
            {isAdminView ? (
              <T context="tooltip for admin view mode toggle">
                Switch to end-user view
              </T>
            ) : (
              <T context="tooltip for end-user view mode toggle">
                Switch to admin view
              </T>
            )}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
